import React, { useEffect, useState } from "react";
import {
  Flex,
  Text,
  Avatar,
  AvatarGroup,
  Image,
  Box,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { useMediaQuery } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { FaRegBell } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { useDisclosure } from "@chakra-ui/react";
import { useLogOut } from "../../../utils/helpers";
import { useNavigate } from "react-router-dom";
import { getUserIdFromToken } from "../../../utils/jwtEmail";
import {
  useGetLoggedInUser,
  useGetStaff,
} from "../../../services/query/account";
import { RiMenuUnfold2Fill } from "react-icons/ri";
import SideDrawer from "./SideDrawer";
// import socket from "../../../services/query/header";

const Header = () => {
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [isUserActive, setIsUserActive] = useState(true);
  const [isMobile] = useMediaQuery("(max-width: 991px)");
  const [title, setTitle] = useState("");
  const location = useLocation();
  let inactivityTimeout = null;
  const locationRoute = location.pathname;
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const {
    isOpen: isDrawerOpen,
    onOpen: onDrawerOpen,
    onClose: onDrawerClose,
  } = useDisclosure();
  const users = [
    { name: "Sam Smith", avatar: "" },
    { name: "Mila Moore", avatar: "" },
    { name: "George Hall", avatar: "" },
    { name: "Chris Kent", avatar: "" },
    { name: "Alex Rider", avatar: "" },
    { name: "Leo Sun", avatar: "" },
  ];

  // useEffect(() => {
  //   const user = {
  //     id: userId,
  //     name: getStaff?.data?.name,
  //     avatar: getStaff?.data?.avatar,
  //     isActive: isUserActive,
  //   };

  //   socket.emit("userStatus", user);
  // }, [isUserActive, getStaff]);

  // useEffect(() => {
  //   const handleActivity = () => {
  //     setIsUserActive(true);
  //     clearTimeout(inactivityTimeout);
  //     inactivityTimeout = setTimeout(
  //       () => {
  //         setIsUserActive(false);
  //       },
  //       5 * 60 * 1000
  //     ); // 5 minutes
  //   };

  //   window.addEventListener("mousemove", handleActivity);
  //   window.addEventListener("keydown", handleActivity);

  //   handleActivity(); // start timer on mount

  //   return () => {
  //     window.removeEventListener("mousemove", handleActivity);
  //     window.removeEventListener("keydown", handleActivity);
  //     clearTimeout(inactivityTimeout);
  //   };
  // }, []);

  // useEffect(() => {
  //   socket.on("onlineUsers", (users) => {
  //     setOnlineUsers(users);
  //   });

  //   return () => {
  //     socket.off("onlineUsers");
  //   };
  // }, []);

  // useEffect(() => {
  //   socket.on("onlineUsers", (users) => {
  //     setOnlineUsers(users);
  //   });

  //   return () => {
  //     socket.off("onlineUsers");
  //   };
  // }, []);

  const maxVisible = 4;
  const visibleUsers = users.slice(0, maxVisible);
  const remainingCount = users.length - maxVisible;

  function getFirstName(fullName) {
    if (!fullName || typeof fullName !== "string") return "";
    return fullName.trim().split(" ")[0];
  }
  // const userId = getUserIdFromToken();
  const { data: loggedInUser, isLoading: isGetting } = useGetLoggedInUser();

  const userName = loggedInUser?.data?.name;

  const logout = useLogOut();

  useEffect(() => {
    switch (true) {
      case locationRoute.includes("dashboard"):
        return setTitle("Dashboard");

      case locationRoute.includes("staff"):
        return setTitle("Staff");

      case locationRoute.includes("log"):
        return setTitle("Work Log");

      case locationRoute.includes("client"):
        return setTitle("Client Management");

      case locationRoute.includes("account"):
        return setTitle("Account Management");

      case locationRoute.includes("settings"):
        return setTitle("Settings");

      default:
        return setTitle("");
    }
  }, [locationRoute]);

  const openOption = (dat) => {
    if (dat.includes("Edit Profile")) {
      navigate(`/staff/${loggedInUser?.id}`);
    } else if (dat.includes("Settings")) {
      navigate(`/settings/departments`);
    } else if (dat.includes("Logout")) {
      logout();
    }
  };

  return (
    <Flex
      flexDirection="column"
      bg="#F1F8FB"
      pos="fixed"
      mx={{ base: "0px", md: "15px" }}
      w={isMobile ? "full" : "calc(100% - 22.5rem)"}
      zIndex="5"
      py="20px"
      px={{ base: "10px", md: "0px" }}
      mt={{ base: "0px", md: "20px" }}
      color="#000"
      borderRadius={{ base: "8px", md: "none" }}
      borderBottom="1px solid #E6EFF5"
    >
      <Flex
        justifyContent="space-between"
        align="center"
        px={isMobile ? "5px" : "24px"}
        w="full"
      >
        <Flex justifyContent="space-between" align="center" w="full">
          <Flex display={{ base: "flex", md: "none" }} align="center">
            <Image
              src="/assets/logo.png"
              w={{ base: "100px", lg: "100px" }}
              h={{ base: "40px", lg: "60px" }}
            />
          </Flex>

          <Flex align="flex-end" gap="4px">
            <Text
              color="#0F172A"
              fontSize={{ base: "16px", md: "24px" }}
              lineHeight={{ base: "20px", md: "30px" }}
              fontWeight={700}
              display={{ base: "none", md: "block" }}
            >
              {title}
            </Text>
          </Flex>

          <Flex
            align="center"
            justifyContent="space-between"
            gap={{ base: "10px", md: "20px" }}
          >
            {/* <AvatarGroup size="sm" max={maxVisible}> */}
            {/* {visibleUsers.map((user, index) => (
                <Avatar
                  key={index}
                  name={user.name}
                  src={user.avatar}
                  bg="#F1F5F9"
                  color="#000080"
                  border="1px solid #4FBAE1"
                />
              ))} */}
            {/* {visibleUsers.map((user, index) => (
                <Avatar
                  key={index}
                  name={user?.name}
                  src={user?.avatar}
                  bg="#F1F5F9"
                  color="#000080"
                  border="1px solid #4FBAE1"
                />
              ))}
              {remainingCount > 0 && (
                <Avatar
                  size="sm"
                  bg="#F1F5F9"
                  color="#000080"
                  border="1px solid #4FBAE1"
                >
                  +{remainingCount}
                </Avatar>
              )} */}
            {/* </AvatarGroup> */}
            <Menu isOpen={isOpen} onClose={onClose}>
              <Flex
                align="center"
                gap="12px"
                bg="#FFF"
                border="1px solid #E4E6E8"
                borderRadius="8px"
                p="8px 10px"
                onClick={onToggle}
                cursor="pointer"
                display={{ base: "none", md: "flex" }}
              >
                <Avatar
                  size="sm"
                  name={userName}
                  src={users[0].avatar}
                  bg="#F1F5F9"
                  color="#000080"
                  fontSize="sm"
                  border="1px solid #4FBAE1"
                />
                <Text fontWeight="medium">{userName}</Text>

                <MenuButton as={Box} cursor="pointer">
                  <IoIosArrowDown />
                </MenuButton>
                <MenuList
                  borderRadius="4px"
                  p="10px"
                  border="1px solid #F4F6F8"
                  boxShadow="0px 8px 16px 0px rgba(0, 0, 0, 0.08)"
                >
                  {["Edit Profile", "Settings", "Logout"].map((dat, index) => (
                    <MenuItem
                      key={index}
                      gap="12px"
                      borderRadius="2px"
                      mb="8px"
                      p="6px 8px"
                      _hover={{ bg: "#F4F6F8" }}
                      align="center"
                      color="#848484"
                      fontWeight="500"
                      onClick={() => {
                        openOption(dat);
                        onClose();
                      }}
                    >
                      {dat}
                    </MenuItem>
                  ))}
                </MenuList>
              </Flex>
            </Menu>
          </Flex>

          <Flex
            gap="10px"
            align="center"
            display={{ base: "flex", lg: "none" }}
          >
            <Flex flexDir="column" pt="5px">
              <Text lineHeight={0.5}>Welcome</Text>
              <Text fontWeight="medium">{userName}</Text>
            </Flex>
            <RiMenuUnfold2Fill
              onClick={onDrawerOpen}
              size={35}
              color="#020071"
            />
          </Flex>
        </Flex>
      </Flex>
      <SideDrawer isOpen={isDrawerOpen} onClose={onDrawerClose} />
    </Flex>
  );
};

export default Header;
